<template>
  <div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddProductoPrecio"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto a la Lista de Precio</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <ProductoSelectComponent :current="current" />
                </div>
                <div class="col-sm-12">
                  <UnidadMedidaSelectComponent
                    :current="current"
                    @onchangeselect="unidadMedidaChange"
                  />
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for>Fecha de Habilitación de Precio</label>
                    <div class="date-input">
                      <input
                        v-model="current.valido_desde"
                        class="single-daterange form-control"
                        placeholder="Fecha de Habilitación de Precio"
                        type="text"
                        value
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for>Fecha de Finalización</label>
                    <div class="date-input">
                      <input
                        v-model="current.valida_hasta"
                        class="single-daterange form-control"
                        placeholder="Fecha de Finalización"
                        type="text"
                        value
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label
                      v-bind:class="{ 'text-danger': current.errors.tipo_calculo && current.errors.tipo_calculo.length > 0 }"
                    >Tipo Calculo</label>
                    <select class="form-control" v-model="current.tipo_calculo">
                      <option value="PORC">Porcentaje</option>
                      <option value="FIJO">Fijo</option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.tipo_calculo"
                      class="form-text text-danger"
                    >{{ current.errors.tipo_calculo[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for>Costo</label>
                    <div class="input-group">
                      <input
                        v-model="current.costo"
                        class="form-control"
                        @change="refrescarPrecioVenta"
                        placeholder="Costo"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for>Margen</label>
                    <div class="input-group">
                      <input
                        v-model="current.margen"
                        @change="refrescarPrecioVenta"
                        class="form-control"
                        placeholder="Margen"
                        type="text"
                      />
                      <div class="input-group-prepend" v-if="current.tipo_calculo == 'PORC'">
                        <div class="input-group-text">%</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 modal-header faded">
                  <div class="col-12">
                    <a class="element-box el-tablo centered trend-in-corner smaller" href="#">
                      <div class="label">Precio de Venta</div>
                      <div class="value">Q {{ precio_venta }}</div>
                      <div
                        class="trending trending-up"
                        style="color:white !important;"
                        v-if="porcentaFrenteUltimoPrecio >= 0"
                      >
                        <span style="color:white !important;">{{ porcentaFrenteUltimoPrecio }}%</span>
                        <i class="os-icon os-icon-arrow-up6"></i>
                      </div>
                      <div
                        class="trending trending-down"
                        style="color:white !important;"
                        v-if="porcentaFrenteUltimoPrecio < 0"
                      >
                        <span style="color:white !important;">{{ porcentaFrenteUltimoPrecio }}%</span>
                        <i class="os-icon os-icon-arrow-down6"></i>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregarPrecio" type="button">Agregar</button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import ListaPreciosService from "@/services/catalogos/ListaPreciosService";
import ListaPreciosProductoService from "@/services/catalogos/ListaPreciosProductoService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import UnidadMedidaSelectComponent from "@/components/commons/UnidadMedidaSelectComponent";

export default {
  components: {
    ProductoSelectComponent,
    UnidadMedidaSelectComponent
  },
  data() {
    return {
      precio_actual: {},
      ultimo_precio: 0,
      precio_venta: 0,
      porcentaFrenteUltimoPrecio: 0,
      current: {
        id: 0,
        nombre: "",
        producto: null,
        unidad_medida: null,
        valido_desde: "",
        costo: 0,
        margen: 5,
        tipo_calculo: "PORC",
        errors: {
          nombre: []
        }
      }
    };
  },
  props: ["lista_precio"],
  watch: {
    producto: function(val) {
      // this.refrescarCosto();
    }
  },
  computed: {
    producto() {
      this.refrescarPrecioVenta();
      return this.current.producto;
    },
    unidad_medida() {
      this.refrescarPrecioVenta();
      return this.current.unidad_medida;
    },
    fecha_str: function() {
      let self = this;
      return self.customFormatter(self.current.fecha);
    }
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then(res => {
      self.current.valido_desde = self.customFormatter(res.data.fecha_actual);
    });
  },
  methods: {
    unidadMedidaChange() {
      this.refrescarCosto();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD 00:00:00");
    },
    refrescarPrecioVenta() {
      let self = this;
      let _precio = 0;
      let _margen = 0;
      let _costo = 0;
      if (self.current.margen) {
        _margen = parseFloat(self.current.margen);
      }
      if (self.current.costo) {
        _costo = parseFloat(self.current.costo);
      }
      if (self.current.tipo_calculo == "PORC") {
        _precio = _costo + _costo * (_margen / 100);
      } else {
        _precio = _costo + _margen;
      }
      _precio = parseFloat(_precio).toFixed(2);
      self.precio_venta = _precio;
      self.calcuarPorcentaFrenteUltimoPrecio();
    },
    calcuarPorcentaFrenteUltimoPrecio() {
      let self = this;

      let _precio_venta = 0;
      if (self.precio_venta) {
        _precio_venta = parseFloat(self.precio_venta);
      }

      let _ultimo_precio = 0;
      if (self.precio_actual.precio_actual) {
        _ultimo_precio = parseFloat(self.precio_actual.precio_actual);
      }
      let diferencia = 0;
      if (_ultimo_precio == 0) {
        diferencia = 100;
      } else {
        diferencia = (_precio_venta * 100) / _ultimo_precio;
        diferencia = diferencia - 100;
      }
      self.porcentaFrenteUltimoPrecio = parseFloat(diferencia).toFixed(2);
    },
    refrescarCosto() {
      let self = this;
      let params = {
        lista_precio: self.lista_precio,
        producto: self.current.producto.sku,
        unidad_medida: self.current.unidad_medida
      };
      ListaPreciosProductoService.fetch(params).then(res => {
        let precios = res.data;
        if (precios.count > 0) {
          self.precio_actual = precios.results[0];
          self.current.costo = self.precio_actual.precio_actual;
          self.ultimo_precio = self.precio_actual.precio_actual;
        } else {
          self.precio_actual = {};
          self.current.costo = 0;
          self.ultimo_precio = 0;
        }
        self.refrescarPrecioVenta();
      });
    },
    cerrandoModal() {
      this.$emit("cerrandomodal");
    },
    agregarPrecio() {
      let self = this;

      var current = Object.assign({}, this.current);
      current.producto = self.current.producto.sku;
      current.lista_precio = self.lista_precio;
      current.valido_desde = self.customFormatterInverted(
        self.current.valido_desde
      );
      if (self.current.valida_hasta) {
        current.valida_hasta = self.customFormatterInverted(
          self.current.valida_hasta
        );
      } else {
        current.valida_hasta = null;
      }
      current.estatus = true;

      ListaPreciosService.agregar_precio(self.lista_precio, current)
        .then(res => {
          self.current.errors = {};
          Notifications.alert.success(
            "Lista de Precio",
            "Se ha agregado nuevo precio"
          );
          self.$refs.cerrarModal.click();
          self.cerrandoModal();
        })
        .catch(error => {
          Vue.nextTick(function() {
            console.log(error.response.data);
            self.current.errors = Object.assign({}, error.response.data);
          });
        });
    }
  }
};
</script>
